import {
	param,
	toggleFullScreen,
	isFullscreen,
	preloadResByGameID,
	getGameNameById,
	screenfullIsEnabled
} from '@/utils';
import Browser from '@/utils/browser.js';
import ifmTool from '@/utils/ifmTool';
import Message from '@/packages/message/index.js';
import Toast from '@/packages/toast/index.js';
import WebInstance from './web';
import NativeInstance from './native';
import store from '@/store/index';
import Loading from '@/packages/loading/index.js';
import PreLoading from '@/packages/preLoading/index.js';
import HotGamePush from '@/packages/hotGamePush/index.js';
import DialogHelp from '@/packages/help/index.js';
import SmallGame from '@/packages/smallGame/index.js';
// import Couplet from '@/packages/couplet/index.js';
import TouchFullSceen from '@/packages/touchFullSceen/index.js';
import Hour2happy from '@/packages/hour2happy/index.js';
// import Tips from "@/packages/tips/index.js";
import DownLoadNative from '@/utils/downLoadNative';
import lifecycleManager from '@/utils/lifecycle.js';
import { setIfmSize } from '@/utils/ui';
import soundManager from '@/utils/soundManager';
import actNotice from '@/logic/actNotice';
import preload from '@/utils/preload';
import preloadNewYearTheme from '@/preloadRes/newYear.js';
import preloadNewYear2020Theme from '@/preloadRes/newYear2020.js';
import preloadCoupletTheme from '@/preloadRes/couplet.js';
import preloadActNotice from '@/preloadRes/actNotice.js';
import preloadHotGamePush from '@/preloadRes/hotGamePush.js';
import preloadHallBgm from '@/preloadRes/hallBgm.js';
import { getEntranceData } from '@/api/entrance';
import { reportBehavior, reportError } from '@/api/report';
import { Base64 } from 'js-base64';
import { getQrFlag, getAppTheme, getLotteryInfo, checkLuckDrawStatus } from '@/api/task';
import DialogNotice from '@/packages/dialogNotice/index.js';
import { getHotGamePush } from "@/api/task";
const qs = require('qs');
const brow = new Browser();
const md5 = require("md5");
//循环上报用户行为
window.loopReport = {
	time: 37 * 1000,
	timer: null,
	fun: null
};

//全局只能有一个音乐播放实例
if (!window.soundInstance) {
	window.soundInstance = new soundManager();
}
new lifecycleManager(
	() => {
		try {
			setTimeout(() => {
				let app = store.state.app,
					appInfo = app.appInfo;
				getHotGamePush({
					game_id: 1000,
					identity: store.state.app.appInfo.identity,
				}).then((res) => {
					res = res.data;
					const stauts = res.result.stauts;
					if (stauts == false) {
						if (window.__dialogNotice) {
							return;
						}
						window.__dialogNotice = DialogNotice.service({
							data: '',
							userKey: app.platform == 0 ? appInfo.identity : store.state.user.userId,
							gameID: 1000,
							xml: 1,//ip禁用
						});
					}
				});
			}, 4 * 1000);
		} catch (e) {
			console.warn("stauts:"+"****")
		}
	},
	() => {
		window.isBackground = false;
		store.dispatch('setBackground', false);
		if (window.soundInstance != null) {
			window.soundInstance.recoverBGM();
		}
		if (window.loopReport.timer == null && window.loopReport.fun != null) {
			window.loopReport.timer = window.setInterval(() => {
				window.loopReport.fun();
			}, window.loopReport.time);
		}
	},
	() => {
		window.isBackground = true;
		store.dispatch('setBackground', true);
		if (window.soundInstance != null) {
			window.soundInstance.pauseBgm();
		}
		if (window.loopReport.timer != null) {
			window.clearInterval(window.loopReport.timer);
			window.loopReport.timer = null;
		}
	}
);

//上报用户行为
export function reportUserBehavior(gameID, roomType, functionID, behaviorID) {
	const gameName = getGameNameById(gameID);
	reportBehavior({
		r: store.state.app.randomID,
		domain: store.state.app.domain,
		identity: store.state.app.appInfo.identity,
		gameName: gameName,
		datetime: new Date().getTime(),
		roomType: roomType,
		gameID: gameID,
		functionID: functionID,
		behaviorID: behaviorID
	});
}

//记录报错信息
export function reportJsError(gameID, message, source, lineno, colno, error) {
	const gameName = getGameNameById(gameID);
	reportError({
		domain: store.state.app.domain,
		identity: store.state.app.appInfo.identity,
		gameName: gameName,
		datetime: new Date().getTime(),
		gameID: gameID,
		message: message,
		source: source,
		lineno: lineno,
		colno: colno,
		error: error
	});
}
//初始化配置相关信息
export function initConfig() {
	//预加载资源
	const preloadResource = preloadActNotice.concat(preloadHotGamePush).concat(preloadHallBgm);
	new preload(preloadResource);
	//获取APP皮肤
	getAppTheme().then((res) => {
		res = res.data;
		if (res.code == 0) {
			const theme = res.result.activity_type;
			store.dispatch('setTheme', theme);
			//预加载新年活动需要的资源
			switch (theme) {
				case 'newYear':
					new preload(preloadNewYearTheme);
					break;
				case 'newYear2020':
					new preload(preloadCoupletTheme.concat(preloadNewYear2020Theme));
					break;
				case 'zhongqiu':

					break;
			}
		}
		store.dispatch('setThemeStatus', 'done');
	});
}

//是否显示提示下载APP的Icon
function checkShowDownAppIcon() {
	return new Promise((resolve, reject) => {
		let appInfo = store.state.app.appInfo;
		const params = {
			identity: appInfo.identity,
			channel_id: appInfo.channel_id
		};
		getQrFlag(params).then((res) => {
			res = res.data;
			if (res.code == 0) {
				if (res.result.flag == 1) {
					store.dispatch('setShowDownLoadIcon', true);
				}
				resolve(res.result.flag);
			} else {
				reject(res.msg);
			}
		});
	});
}

//获取参数
export function getParams() {
	return param(store.state.app.appInfo);
}

//通过游戏ID设置自动跳转信息(用于热门游戏跳转和游戏中跳转游戏)
export function jumpGameByGameID(gameId) {
	let platform = store.state.app.platform;
	const actZIndex = store.state.app.actZIndex;
	//如果actifm有打开则先关闭
	if (actZIndex == 5) {
		//关闭活动iframe
		resetActIframe();
		window.soundInstance.unloadBgm();
	}
	//web
	if (platform == 0) {
		store.dispatch('setOpenGameID', gameId);
		ifmTool.closeGame();
	} else {
		//app
		initApp(gameId, true).then((res) => {
			window.nativeUtils.getGameInfo(gameId).then((e) => {
				if (e) {
					const gameInfo = JSON.parse(e);
					if (gameInfo.version) {
						if (
							parseInt(String(gameInfo.version).split('.').join('')) ==
							parseInt(String(res.version).split('.').join(''))
						) {
							store.dispatch('setOpenGameUrl', gameInfo.native_url);
							ifmTool.closeGame();
						} else {
							Toast.service('这个游戏还没有更新，请返回大厅进行更新');
						}
					} else {
						Toast.service('这个游戏还没有下载，请返回大厅进行下载');
					}
				} else {
					Toast.service('这个游戏还没有下载，请返回大厅进行下载');
				}
			});
		});
	}
}

//获取初始化数据,flg为1则不获取在房间内的信息
export function initApp(serverType, flag) {
	const appInfo = store.state.app.appInfo;
	const lang = store.state.app.lang;
	if (!appInfo.identity) {
		Toast.service('缺少参数: identity');
		return;
	}
	if (!appInfo.channel_id) {
		Toast.service('缺少参数: channel_id');
		return;
	}
	if (!appInfo.domain) {
		Toast.service('缺少参数: domain');
		return;
	}
	if (appInfo.identity) {
		if (!appInfo.extra) {
			Toast.service(lang == 'cn' ? '链接失效**' : 'Broken link');
			return;
		} else {
			let xx = appInfo.extra;
			let endidentity = decodeURIComponent(appInfo.identity);
			let uu = endidentity.substring(2, 5) + appInfo.server_type;
			const hh = md5(uu);
			if (xx != hh) {
				Toast.service(lang == 'cn' ? '链接失效*' : 'Broken link');
				return;
			}
		}
	}
	let params = {
		identity: appInfo.identity,
		channel_id: appInfo.channel_id,
		server_type: serverType || appInfo.server_type || 1000,
		is_app: store.state.app.platform
	};
	//const lang = store.state.app.lang;
	if (flag) {
		params.flg = 1;
	}
	return new Promise((resolve, reject) => {
		getEntranceData(params).then((res) => {
			res = res.data;
			if (res.code == 0) {
				resolve(res);
			} else if (res.code == 6000) {
				if (params.is_app == 0) {
					resolve(res);
				} else {
					if (window.__loading) {
						window.__loading.close();
						window.__loading = null;
					}
					Message.service({
						content: '游戏正在维护中，稍后将有更多精彩的内容，请耐心等待~',
						confirmText: '确认',
						confirmCallback: () => {
							window.location.reload();
						}
					});
				}
			} else {
				const errMsg =
					lang == 'cn' ? '您的连接已过期，请关闭页面，重新登入。' : 'Session expired. Please close the page and Login Again！';
				reject(errMsg);
			}
		});
	});
}

//获取加载游戏是否使用自定义Logo的参数
export function getCustomLogoUrl(url) {
	let appInfo = store.state.app.appInfo;
	const customLogo = {
		logo_type: appInfo.logo_type,
		logo_url: appInfo.logo_url,
		style: appInfo.style
	};
	const p = qs.stringify(customLogo);
	if (url.indexOf('?') > -1) {
		url += '&' + p;
	} else {
		url += '?' + p;
	}
	return url;
}

//获取加载游戏是否使用自定义Logo的参数附带语言字段
export function getGameCustomLogoUrl(url) {
	let appInfo = store.state.app.appInfo;
	const customLogo = {
		logo_type: appInfo.logo_type,
		logo_url: appInfo.logo_url,
		switch_lang: appInfo.switch_lang,
		lang: appInfo.lang,
		style: appInfo.style
	};
	const p = qs.stringify(customLogo);
	if (url.indexOf('?') > -1) {
		url += '&' + p;
	} else {
		url += '?' + p;
	}
	return url;
}

//把游戏的iframe置顶
function showGameIframe() {
	store.dispatch('setGameZIndex', 4);
}

//重置游戏的iframe为2
function resetGameIframeZIndex() {
	store.dispatch('setGameZIndex', 2);
}

/** 把活动的iframe置顶 */
function showActIframe() {
	store.dispatch('setActZIndex', 5);
}
// /**隐藏活动的iframe */
function resetActIframe() {
	store.dispatch('setActZIndex', -1);
	store.dispatch('setActIfmUrl', 'blank.html');
}

/**设置活动的iframe地址 */
export function setActIframeUrl(gameID) {
	let url = '';
	if (gameID != 1000) {
		window.__preLoading = PreLoading.service();
		const { identity, channel_id, domain, style } = store.state.app.appInfo;
		url = `https://${store.state.app.domain.replace('gw.', 'game.').replace(':443', '')}/activity/index.html?identity=${identity}&channel_id=${channel_id}&style=${style}&domain=${domain}&game_id=${store.state.app.currentGameID}&v=${new Date().getTime()}`;
	}
	store.dispatch('setActIfmUrl', url);
}

//设置游戏地址
export function setGameUrl(u, patchParams) {
	if (patchParams) {
		u = `${u}?${getParams()}&v=${new Date().getTime()}`;
	}
	const url = getGameCustomLogoUrl(u);
	store.dispatch('setGameIfmUrl', url);
}

//设置大厅地址
export function setHallUrl(u, patchParams) {
	if (patchParams) {
		u = `${u}?${getParams()}&v=${new Date().getTime()}`;
	}
	const url = getCustomLogoUrl(u);
	store.dispatch('setHallIfmUrl', url);
}

//关闭热门游戏弹窗
export function closeHotGamePush() {
	if (window._hotGamePush != null) {
		window._hotGamePush.close();
		window._hotGamePush = null;
		window._hotGamePushID = null;
	}
}
//显示热门弹窗
export function showHotGamePush(gameID) {
	if (window._hotGamePush != null) {
		window._hotGamePush.close();
	}
	window._hotGamePushID = gameID;
	window._hotGamePush = HotGamePush.service({
		gameID: gameID,
		vertical: brow.getDirection() == 'vertical' ? true : false
	});
}

//刷新游戏
export function reloadGame() {
	let app = store.state.app;
	if (app.gameIfmUrl == '') {
		window.__loading = Loading.service({
			showLogo: true
		});
	} else {
		resetGameIframeZIndex();
		window.__loading = Loading.service({
			showLogo: true
		});
	}
	ifmTool.reload();
}

//打开指定游戏
function openGame(returnType) {
	let app = store.state.app;
	resetGameIframeZIndex();
	window.__loading = Loading.service({
		text: '加载中',
		showLogo: false
	});
	/**延时一秒请求 */
	setTimeout(() => {
		//web
		if (app.platform == 0) {
			initApp(app.openGameID).then((res) => {
				if (returnType == 1 || app.gameIfmUrl == '') {
					setHallUrl(res.entrace_url, true);
				} else {
					setGameUrl(res.entrace_url, true);
				}
				store.dispatch('setOpenGameID', '');
			});
		} else {
			//app
			if (returnType == 1 || app.gameIfmUrl == '') {
				setHallUrl(app.openGameUrl, true);
			} else {
				setGameUrl(app.openGameUrl, true);
			}
			store.dispatch('setOpenGameUrl', '');
		}
	}, 1 * 1000);
}

//注册iframe回调
export function registerIframeCallback() {
	window.addEventListener('message', function (rs) {
		if (rs.data) {
			switch (rs.data.action) {
				case 'return_url':
					if (store.state.app.return_url) {
						window.location.href = Base64.decode(store.state.app.return_url);
					}
					break;
				case 'toggleFullScreen':
					toggleFullScreen();
					ifmTool.postFullSceenInfo(isFullscreen ? 1 : 0);
					break;
				case 'setGameIframe':
					{
						setGameUrl(rs.data.url, false);
					}
					break;
				case 'openGameViewFromHall':
					{
						//游戏总大厅打开的游戏界面
						const isApp = rs.data.isApp;
						if (!isApp) {
							/**web */
							initApp(rs.data.gameInfo).then((res) => {
								setGameUrl(res.entrace_url, true);
							});
						}
						else {
							/**native */
							setGameUrl(rs.data.gameInfo, true);
						}
					}
					break;
				case 'showGameIframe':
					showGameIframe();
					break;
				case 'hideGameIframe':
					{
						//返回的时候停止播放音乐
						window.soundInstance.unloadBgm();
						store.dispatch('setGameID', 1000);
						closeHotGamePush();
						store.dispatch('setShowLuckyWheelEntrance', false);
						if (
							!brow.isIos() &&
							screenfullIsEnabled() &&
							brow.getPlatform() == 0 &&
							store.state.app.appInfo.fullscreen_btn == 1 &&
							window.__touchFullSceen
						) {
							window.__touchFullSceen.close();
							window.__touchFullSceen = null;
						}
						window.loopReport.fun = null;
						let app = store.state.app;
						if (window.__hour2happy) {
							window.__hour2happy.remove();
						}
						//如果是热门游戏推荐
						if (app.openGameID != '' || app.openGameUrl != '') {
							openGame(app.return_type);
						} else {
							if (app.return_type == 1) {
								window.location.reload();
							} else {
								if (app.server_type != 1000 && app.return_url) {
									window.location.href = Base64.decode(app.return_url);
								} else {
									if (app.gameIfmUrl == '') {
										store.dispatch('setHallZIndex', -1);
										window.__loading = Loading.service();
										if (app.platform == 0) {
											new WebInstance().init(1000);
										} else {
											new NativeInstance().init();
										}
									} else {
										ifmTool.activeGameHall();
										store.dispatch('setGameIfmUrl', 'blank.html');
										resetGameIframeZIndex();
									}
								}
							}
						}
						//显示雪花
						store.dispatch('setShowSnow', true);
					}
					break;
				case 'showLoading':
					{
						const style = rs.data.style || 1;
						window.__loading = Loading.service({
							text: '加载中',
							showLogo: style == 1 ? false : true
						});
					}
					break;
				case 'hideLoading':
					if (window.__loading) {
						window.__loading.close();
						window.__loading = null;
					}
					break;
				case 'closeLoadingAndShowGame':
					{
						setIfmSize();
						const gameID = rs.data.game_id;
						if (gameID) {
							//预加载游戏BGM
							preloadResByGameID(gameID);
							store.dispatch('setGameID', gameID);
						}
						let app = store.state.app;
						if (window.__loading) {
							window.__loading.close();
							window.__loading = null;
						}
						store.dispatch('setHallZIndex', 3);
						store.dispatch('setBlueBg', false);
						resetGameIframeZIndex();
						if (
							store.state.app.gameIfmUrl != '' &&
							store.state.app.gameIfmUrl.indexOf('blank.html') == -1
						) {
							ifmTool.stopGameHall();
							showGameIframe();
							//显示对联
							// if (!window.__couplet) {
							// 	window.__couplet = Couplet.service();
							// }
						} else {
							if (app.platform == 0) {
								checkShowDownAppIcon();
							}
							if (app.openGameID != '' || app.openGameUrl != '') {
								openGame();
							}
						}
						//不是大厅才显示时时乐
						if (gameID != 1000) {
							//获取时时彩的信息
							const params = {
								identity: store.state.app.appInfo.identity
							};
							getLotteryInfo(params).then((res) => {
								res = res.data;
								if (res.code == 0 && res.result && res.result.flag) {
									window.__hour2happy = Hour2happy.service(res);
								}
							});
						}
						//显示雪花
						store.dispatch('setShowSnow', true);
					}
					break;
				case 'downLoadGame':
					{
						const gameID = rs.data.gameID;
						const url = rs.data.url;
						const version = rs.data.version;
						new DownLoadNative(gameID, url, version, false, null).init();
					}
					break;
				case 'enterGameHall':
					{
						setIfmSize();
						if (window.__tips) {
							window.__tips.destory();
							window.__tips = null;
						}
						if (window.loopReport.timer != null) {
							window.clearInterval(window.loopReport.timer);
							window.loopReport.timer = null;
						}
						const gameID = rs.data.game_id;
						if (gameID != 1000) {
							actNotice.init(gameID);
							store.dispatch('setShowSnow', false);
							// if (window.__couplet) {
							// 	window.__couplet.remove();
							// 	window.__couplet = null;
							// }
							//进游戏房间统计
							reportUserBehavior(gameID, 0, 8000, 3);
							window.loopReport.fun = () => {
								reportUserBehavior(gameID, 0, 8000, 6);
							};
							//在卓内的统计上报
							window.loopReport.timer = window.setInterval(() => {
								reportUserBehavior(gameID, 0, 8000, 6);
							}, window.loopReport.time);
							if (
								!brow.isIos() &&
								screenfullIsEnabled() &&
								brow.getPlatform() == 0 &&
								store.state.app.appInfo.fullscreen_btn == 1
							) {
								if (window.__touchFullSceen) {
									window.__touchFullSceen.close();
								}
								window.__touchFullSceen = TouchFullSceen.service();
							}
							/** 检查是否开启了幸运轮盘，没开启则关闭 */
							store.dispatch('setCanShowLuckyWheelEntrance', true);
							checkLuckDrawStatus().then((res) => {
								res = res.data;
								if (res.code == 0) {
									if (res.result.lucky_draw == 1) {
										store.dispatch('setShowLuckyWheelEntrance', true);
										/** 有活动，更新红点 */
										store.dispatch('setluckyRedNum', res.result.how_many_award_can_receive);
									}
									else {
										store.dispatch('setShowLuckyWheelEntrance', false);
									}
								}
								else {
									store.dispatch('setShowLuckyWheelEntrance', false);
								}
							})

							if (gameID == 1051) {
								/**如果是金蟾捕鱼返回大厅则显示热门游戏推荐 */
								showHotGamePush(1051);
							}

						}
					}
					break;
				case 'enterGameRoom':
					{
						store.dispatch('setShowSnow', false);
						if (window.loopReport.timer != null) {
							window.clearInterval(window.loopReport.timer);
							window.loopReport.timer = null;
						}
						const gameID = rs.data.game_id;
						const roomType = rs.data.room_type;
						window.loopReport.fun = () => {
							reportUserBehavior(gameID, roomType, 8000, 7);
						};
						//在卓内的统计上报
						window.loopReport.timer = window.setInterval(() => {
							reportUserBehavior(gameID, roomType, 8000, 7);
						}, window.loopReport.time);
						if (
							!brow.isIos() &&
							screenfullIsEnabled() &&
							brow.getPlatform() == 0 &&
							store.state.app.appInfo.fullscreen_btn == 1 &&
							window.__touchFullSceen
						) {
							window.__touchFullSceen.close();
							window.__touchFullSceen = null;
						}
						resetActIframe();
						store.dispatch('setShowLuckyWheelEntrance', false);
						store.dispatch('setCanShowLuckyWheelEntrance', false);
						if (window.__preLoading) {
							window.__preLoading.remove();
							window.__preLoading = null;
						}
						if (gameID == 1051) {
							/**如果是金蟾捕鱼进桌内，则先隐藏热门游戏推荐按钮 */
							closeHotGamePush();
						}
					}
					break;
				case 'showHotGamePush':
					{
						const gameID = rs.data.game_id;
						showHotGamePush(gameID);
					}
					break;
				case 'hideHotGamePush':
					{
						closeHotGamePush();
					}
					break;
				case 'resetHotGameID':
					{
						store.dispatch('setOpenGameID', '');
						store.dispatch('setOpenGameUrl', '');
					}
					break;
				case 'jsErrorReport':
					{
						reportJsError(
							rs.data.game_id,
							rs.data.message,
							rs.data.source,
							rs.data.lineno,
							rs.data.colno,
							rs.data.error
						);
					}
					break;
				case 'closeAllPopUps':
					{
						store.dispatch('setCloseAllPopUp', 'all');
						store.dispatch('setGaussianBlur', false);
						if (window.__loading) {
							window.__loading.close();
							window.__loading = null;
						}
					}
					break;
				case 'toast':
					{
						const msg = rs.data.msg;
						Toast.service(msg);
					}
					break;
				case 'activateBgm':
					{
						window.soundInstance.recoverBGM();
					}
					break;
				case 'unloadBgm':
					{
						//停止播放音乐
						window.soundInstance.unloadBgm();
					}
					break;
				case 'playBgm':
					{
						//播放BGM，key=0为游戏大厅BGM,key=1为游戏房间BGM
						const gameID = rs.data.game_id;
						const key = rs.data.key;
						window.soundInstance.playBgm(gameID, key);
					}
					break;
				case 'setBgmVolume':
					{
						//设置BGM音量,volume(百分制)
						const volume = rs.data.volume;
						window.soundInstance.setBgmVolume(volume);
					}
					break;
				case 'setEffectVolume':
					{
						//设置音效音量,volume(百分制)
						const volume = rs.data.volume;
						window.soundInstance.setEffectVolume(volume);
					}
					break;
				case 'setBgmStatus':
					{
						//设置BGM开关,switch(1为开，0为关)
						const _switch = rs.data.switch;
						window.soundInstance.setBgmStatus(_switch);
					}
					break;
				case 'setEffectStatus':
					{
						//设置音效开关,switch(1为开，0为关)
						const _switch = rs.data.switch;
						window.soundInstance.setEffectStatus(_switch);
					}
					break;
				case 'configMiniGame':
					{
						//小游戏初始化配置信息
						const configData = JSON.parse(rs.data.data).data;
						ifmTool.configMiniGame(configData);
					}
					break;
				case 'showMiniGame':
					{
						//打开小游戏
						if (window._smallGame != null) {
							window._smallGame.close();
							window._smallGame = null;
						}
						const resData = JSON.parse(rs.data.data);
						if (resData.code == 0) {
							const jsonData = resData.data;
							window._smallGame = SmallGame.service({
								MiniGameId: jsonData.MiniGameId,
								WinPos: jsonData.WinPos,
								WinGold: jsonData.WinGold,
								ResultList: jsonData.ResultList,
								Bet: jsonData.Bet
							});
							store.dispatch('setGaussianBlur', true);
						} else {
							store.dispatch('setGaussianBlur', false);
							Message.service({
								content: resData.msg,
								confirmText: '确认',
								confirmCallback: () => {
									ifmTool.confirmGame(0);
								}
							});
						}
					}
					break;
				case 'reportUserBehavior':
					{
						//gameID room_type,function_id,behaviorID
						const behaviorId = rs.data.behavior_id;
						reportUserBehavior(
							rs.data.game_id,
							rs.data.room_type,
							rs.data.function_id,
							behaviorId
						);
						//如果是点击游戏房间入口
						if (behaviorId == 4) {
							resetActIframe();
							store.dispatch('setShowLuckyWheelEntrance', false);
						}
					}
					break;
				case 'reload':
					{
						window.location.reload();
					}
					break;
				case 'reloadGame':
					{
						let app = store.state.app;
						if (app.gameIfmUrl == '') {
							window.__loading = Loading.service({
								showLogo: true
							});
						} else {
							resetGameIframeZIndex();
							window.__loading = Loading.service({
								showLogo: true
							});
						}
					}
					break;
				case 'showHelp':
					{
						if (window.__dialogHelp) {
							return;
						}
						window.__dialogHelp = DialogHelp.service({
							gameId: rs.data.game_id,
							lang: rs.data.lang,
							style: rs.data.style || 1
						});
					}
					break;
				case 'console':
					{
						switch (rs.data.type) {
							case 'log':
								console.log(JSON.stringify(rs.data.data));
								break;
							case 'error':
								console.error(JSON.stringify(rs.data.data));
								break;
							case 'warn':
								console.warn(JSON.stringify(rs.data.data));
								break;
							case 'info':
								console.info(JSON.stringify(rs.data.data));
								break;
						}
					}
					break;
				case 'openGame':
					{
						const gameId = rs.data.gameId;
						jumpGameByGameID(gameId);
					}
					break;
				case 'loadingProgress':
					{
						//同步加载进度
						const loadingProgress = rs.data.data;
						store.dispatch('setLoadingProgress', loadingProgress);
					}
					break;
				case 'showActIfm':
					{
						//显示活动iframe
						showActIframe();
						window.soundInstance.playBgm(store.state.app.currentGameID, 'luckyWheel');
						store.dispatch('setShowLuckyWheelEntrance', false);
						if (window.__preLoading) {
							window.__preLoading.remove();
							window.__preLoading = null;
						}
					}
					break;
				case 'closeActIfm':
					{
						//关闭活动iframe
						resetActIframe();
						store.dispatch('setShowLuckyWheelEntrance', true);
						window.soundInstance.playBgm(store.state.app.currentGameID, 0);
						ifmTool.actIfmClosed();
					}
					break;
				case 'updateUserGold':
					{
						//**更新用户余额信息 */
						const gold = rs.data.gold;
						ifmTool.updateUserGold(gold);
					}
					break;
				case 'updateRedNum':
					{
						/**更新红点数量 */
						const num = rs.data.num;
						store.dispatch('setluckyRedNum', num);
					}
					break;
				case 'changeLang':
					{
						/***切换语言*/
						const lang = rs.data.lang;
						let app = store.state.app;
						let appInfo = app.appInfo;
						appInfo.lang = rs.data.lang;
						appInfo.v = new Date().getTime();
						const gameUrl = `${rs.data.gameUrl}?${qs.stringify(appInfo)}`;
						if (app.gameIfmUrl == '') {
							window.__loading = Loading.service({
								showLogo: true,
								changeLang: lang
							});
							store.dispatch('setHallIfmUrl', gameUrl);
						} else {
							resetGameIframeZIndex();
							window.__loading = Loading.service({
								showLogo: true,
								changeLang: lang
							});
							store.dispatch('setGameIfmUrl', gameUrl);
						}
					}
			}
		}
	});
}
